import script from "./BaseInputQuantity.vue?vue&type=script&lang=ts&setup=true"
export * from "./BaseInputQuantity.vue?vue&type=script&lang=ts&setup=true"

import "./BaseInputQuantity.vue?vue&type=style&index=0&id=55e6aad8&lang=css"

const __exports__ = script;

export default __exports__